import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider } from "formik";
// import * as Yup from "yup";
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
// import { Inbox } from "@material-ui/icons";

const ProductionOrdersUpdatePlannedDate = () => {
  let { id } = useParams();
  const [value, setValue] = useState({});
  const [menu, setMenu] = useState(false);
  const [backendErrors, setBackendErrors] = useState([]);
    const [permission, setPermission] = useState({});
  
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [defaultDate, setDefaultDate] = useState(formatDate(new Date()));

  useEffect(() => {
        setPermission(FindModuleById(401)); 
console.log(permission);

    axios
      .get(`/orders/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
         // toast.error(response.data.data.order);
          setValue(response.data.data.order);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const formik = useFormik({
    initialValues: {
      id: value.id,
      planned_production_date: (value.planned_production_date && value.planned_production_date != "")?value.planned_production_date:defaultDate,
    },
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/production-orders/update-production-planned-date", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Update Date"); 
         delete backendErrors['error'];
         //  actions.setSubmitting(false);
         setSubmitting(false);
           if (response.data.code === 200) {
            //  setBackendSuccess(response.data.message);
             toast.success(response.data.message);
            // actions.resetForm();
             setTimeout(() => {
               window.location.href = "/production-orders/";
             }, 500);
           }  else if (response.data.code === 422) {
               setBackendErrors(response.data.error);
           }
           else if (response.data.code === 401) {
             setBackendErrors(response.data.error);
           }
           else {
              setBackendErrors(response.data.error);
           }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />  <ToastContainer />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Update Planned Production Date</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/production-orders-view/${value.id}`} >
                      Production Orders
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Update Planned Production Date 
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title"> Update Planned Production Date</h4>
                    <FormikProvider value={formik}>
                      <form onSubmit={formik.handleSubmit}>
                     
                        <div className="row">
                          <div className="col-md-2">
                              <div className="form-group">
                                <label>Planned Production Date</label>
                                <input
                                  type="date"
                                  className="form-input form-control"
                                  name="planned_production_date"
                                  value={formik.values.planned_production_date}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                    setDefaultDate(e.target.value);
                                  }}
                                  onBlur={formik.handleBlur}
                                
                                />
                                <small>
                                  {backendErrors.planned_production_date && (
                                      <span className="form-error mt-1">
                                        {backendErrors.planned_production_date}
                                      </span>
                                    )}
                                </small>
                              </div>
                            </div>
                            {/* <div className="col-md-4"></div> */}
                            <div className="col-md-2">
                                <div className="text-end mt-4">
                                <button className="btn btn-primary" type="submit" id="form-submit" disabled={formik.isSubmitting}>
                                Update Date 
                                </button>
                              </div>
                            </div>


                            </div>



                       
                      </form>
                    </FormikProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductionOrdersUpdatePlannedDate;
